import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 21v-6m0 -6v-1a4 4 0 1 0 -4 4h13","key":"svg-0"}],["path",{"d":"M17 16l4 -4l-4 -4","key":"svg-1"}]]

const IconArrowLoopRight2 = createReactComponent('outline', 'arrow-loop-right-2', 'ArrowLoopRight2', __iconNode);

export default IconArrowLoopRight2;